export const StepHead = ({ current }) => {
  return (
    <div className="step-header">
      <div className={`step-item ${current >= 1 ? "active" : ""}`}>
        <div className="step-circle">{current > 1 ? "✓" : "1"}</div>
        <span>Doctor Basic Details</span>
      </div>

      <div className="step-line" />

      <div className={`step-item ${current >= 2 ? "active" : ""}`}>
        <div className="step-circle">{current > 2 ? "✓" : "2"}</div>
        <span>Doctor Additional Details</span>
      </div>

      {/* <div className="step-line" />

      <div className={`step-item ${current >= 3 ? "active" : ""}`}>
        <div className="step-circle">{current > 3 ? "✓" : "3"}</div>
        <span>Additional Details</span>
      </div>

      <div className="step-line" />

      <div className={`step-item ${current >= 4 ? "active" : ""}`}>
        <div className="step-circle">{current > 4 ? "✓" : "4"}</div>
        <span>Medicines & Bank Documents</span>
      </div> */}
      {/* <div className="step-line" />

      <div className={`step-item ${current >= 5 ? "active" : ""}`}>
        <div className="step-circle">{current > 5 ? "✓" : "5"}</div>
        <span>Review</span>
      </div> */}
    </div>
  );
};
